import { registerPlugin } from '@capacitor/core';
const MoECapacitorCore = registerPlugin('MoECapacitorCore', {});
export * from './definitions';
export { MoECapacitorCore };
//# sourceMappingURL=index.js.map